// 데이터 처리 및 분류 경계 생성 관련

export const parseNumbers = (text = '') =>
    text
        .split(',')
        .map((token) => Number(token.trim()))
        .filter((value) => Number.isFinite(value))
        .sort((a, b) => a - b);

export const buildCustomBreaks = (steps, customList) => {
    const breaks = [];
    const list = customList.length ? customList : [0];
    for (let i = 1; i <= steps; i += 1) {
        if (i === steps) {
            breaks.push(Number.POSITIVE_INFINITY);
        } else {
            breaks.push(list[Math.min(i - 1, list.length - 1)]);
        }
    }
    return breaks;
};

export const buildEqualBreaks = (values, steps) => {
    const sorted = [...values].sort((a, b) => a - b);
    const min = sorted[0];
    const max = sorted[sorted.length - 1];
    if (!Number.isFinite(min) || !Number.isFinite(max) || min === max) {
        return Array.from({ length: steps - 1 }, () => min ?? 0).concat(Number.POSITIVE_INFINITY);
    }
    const interval = (max - min) / steps;
    const breaks = [];
    for (let i = 1; i <= steps; i += 1) {
        if (i === steps) {
            breaks.push(Number.POSITIVE_INFINITY);
        } else {
            breaks.push(min + interval * i);
        }
    }
    return breaks;
};

export const buildQuantileBreaks = (values, steps) => {
    const sorted = [...values].sort((a, b) => a - b);
    const breaks = [];
    for (let i = 1; i <= steps; i += 1) {
        if (i === steps) {
            breaks.push(Number.POSITIVE_INFINITY);
        } else {
            const idx = Math.min(sorted.length - 1, Math.ceil((sorted.length * i) / steps) - 1);
            breaks.push(sorted[idx]);
        }
    }
    return breaks;
};

export const ensureClassification = (layer) => ({
    field: '',
    method: 'equal',
    steps: 5,
    customBreaks: '',
    palette: 'blues',
    ...layer.classification,
});

export const computeClassificationBreaks = (values, steps, method, customBreaks) => {
    if (!values.length || !steps) return null;
    if (method === 'custom') {
        const customList = parseNumbers(customBreaks);
        return buildCustomBreaks(steps, customList);
    }
    if (method === 'quantile') {
        return buildQuantileBreaks(values, steps);
    }
    return buildEqualBreaks(values, steps);
};

// 레이어 객체에 지오메트리 스타일 기본값 지정
export const ensureLegend = (layer) => {
    const defaults = {
        point: { fill: '#ff7043', stroke: '#bf360c', radius: 8, opacity: 0.9 },
        line: { stroke: '#1565c0', width: 3, opacity: 1 },
        polygon: { fill: '#26a69a', stroke: '#00695c', width: 2, opacity: 0.85 },
    };
    return {
        point: { ...defaults.point, ...(layer.styles?.point ?? {}) },
        line: { ...defaults.line, ...(layer.styles?.line ?? {}) },
        polygon: { ...defaults.polygon, ...(layer.styles?.polygon ?? {}) },
    };
};